import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Gauge } from "lucide-react";

export default function ScorecardPromo() {
  return (
    <section id="scorecard" data-testid="scorecard-promo-section" className="py-16 md:py-20 bg-[#0B0F19]">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.05] to-white/[0.02] p-8 sm:p-12 overflow-hidden"
        >
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-cyan-500/10 blur-[100px]" />
          <div className="relative grid lg:grid-cols-[1fr_auto] gap-8 items-center">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="h-10 w-10 rounded-xl bg-cyan-500/10 text-cyan-300 flex items-center justify-center">
                  <Gauge size={20} strokeWidth={1.75} />
                </div>
                <span className="text-xs font-bold uppercase tracking-widest text-cyan-300">
                  Free 5-Minute Assessment
                </span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight leading-tight">
                Not ready for a full audit?{" "}
                <span className="text-gradient">Start with the Lead Leakage Scorecard.</span>
              </h2>
              <p className="mt-4 text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl">
                Eight quick questions show you exactly where buyer and seller opportunities may be
                slipping — across capture, response, qualification, follow-up, booking, and
                tracking — with three prioritized recommendations and a 7-day improvement plan.
              </p>
            </div>
            <div className="lg:text-right">
              <Link
                to="/scorecard"
                data-testid="scorecard-promo-button"
                data-track="scorecard_promo_clicked"
                className="group inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 bg-indigo-600 hover:bg-indigo-500 font-semibold text-white transition-[background-color,transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_0_24px_rgba(99,102,241,0.45)]"
              >
                Start the Scorecard
                <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
              <p className="mt-3 text-xs text-slate-500">Instant results · No email required</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
